module.exports = __webpack_public_path__ + "img/footer_nezam_10.ca13a438.svg";